/**
 * @file FormRegistration
 */
'use strict';

/**
 * @classname FormRegistration
 * @classdesc 登録
 */
export default class FormRegistration {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormRegistration
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormRegistration.preProcessing');
		// バリデーション後に行う処理を記載（開始）

		// バリデーション後に行う処理を記載（終了）
		this._controller.completePreProcessing($form);
	};


	/**
	 * エラー表示
	 *
	 * @memberof FormRegistration
	 * @return {undefined}
	 */
	showError() {
		console.log('FormRegistration.showError');
		$('.stars-wrap')
			.addClass('is-invalid')
			.closest('.form-content')
			.find('.error-tip')
			.addClass('show')
			.find('.error-tip-inner');
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof FormRegistration
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormRegistration.postProcessing');
		// バリデーション後に行う処理を記載（開始）

		if(this._controller._memberFlg && $('.member_type:checked').val() === '2'){
			$('#ob_og_y').removeAttr('name');
			$('#ob_og_n').removeAttr('name');
			$('#ob_og2_y').attr('name', 'ob_og');
			$('#ob_og2_n').attr('name', 'ob_og');
			$('#protection_enabled_y').removeAttr('name');
			$('#protection_enabled_n').removeAttr('name');
			$('#protection_enabled2_y').attr('name', 'protection_enabled');
			$('#protection_enabled2_n').attr('name', 'protection_enabled');
			$('#ob_email').removeAttr('name');
		}else{
			$('#ob_og2_y').removeAttr('name');
			$('#ob_og2_n').removeAttr('name');
			$('#protection_enabled2_y').removeAttr('name');
			$('#protection_enabled2_n').removeAttr('name');
			$('#ob_email2').removeAttr('name');
		}

		// バリデーション後に行う処理を記載（終了）
		this._controller.completePostProcessing($form);
	};
}
